import { observer } from "mobx-react"
import React from "react"
import { Component } from "react"
import { Link } from "react-router-dom"
import { Divider, Dropdown } from "semantic-ui-react"
import categoryStore from "stores/categoryStore"

@observer
export default class CategoryDropdown extends Component {

  render() {
    const {fluid = true} = this.props
    const { categories } = categoryStore
    return <Dropdown fluid={fluid} style={{ width: "140px" }}  item text={<span className="pre pr2">{translate("Zur Startseite")}</span>}>
      <Dropdown.Menu>
        <Dropdown.Item text={<span className="pre ">{translate("Zur Startseite")}</span>} as={Link} to={"/home"}/>
        <Divider/>
        {categories.map( category => <Dropdown.Item key={category.map_id} text={category.title} as={Link} to={`/collection/${category.map_id}`}/> )}
      </Dropdown.Menu>
    </Dropdown>
  }
}


// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Category/CategoryDropdown.js